import { render } from "./Methodology.vue?vue&type=template&id=51a72428"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mayankmunjal/Desktop/Mayank MS2/major-studio-2-sp24/08-vue-deploy/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__